import { render } from "./MenuItem.vue?vue&type=template&id=f10c1e8c"
import script from "./MenuItem.vue?vue&type=script&lang=js"
export * from "./MenuItem.vue?vue&type=script&lang=js"
script.render = render

export default script